import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultCampaignPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};
const defaultCampaignPaginationFilter = {
	$skip: defaultCampaignPagination.$skip,
	$limit: defaultCampaignPagination.$limit,
};
const defaultTargetUserListPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};
const defaultTargetUserListPaginationFilter = {
	$skip: defaultTargetUserListPagination.$skip,
	$limit: defaultTargetUserListPagination.$limit,
};

const defaultCampaignUserListPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};
const defaultCampaignUseListFilter ={
	$skip: defaultCampaignUserListPagination.$skip,
	$limit: defaultCampaignUserListPagination.$limit,
};
export default {
	state: {
		campaign:[],
		campaignPagination:defaultCampaignPagination,
		campaignPaginationFilter:defaultCampaignPaginationFilter,
		targetUserList: [],
		targetUserListPagination: defaultTargetUserListPagination,
		targetUserListPaginationFilter :defaultTargetUserListPaginationFilter,
		campaignUser:[],
		campaignUserListPagination:defaultCampaignUserListPagination,
		campaignUserListFilter :defaultCampaignUseListFilter,
		trustSKills:[],
		targetUserHasSkill: [],
	},
	getters: {
		campaignPage: (state) => {
			const { $limit, $skip } = state.campaignPagination;
			return $skip / $limit + 1;
		},
		targetUserListPage:(state) => {
			const { $limit, $skip } = state.targetUserListPagination;
			return $skip / $limit + 1;
		},
		campaignUserListPage:(state) =>{
			const { $limit, $skip } = state.campaignUserListPagination;
			return $skip / $limit + 1;
		},
		targetUserHasSkill: (state) => state.targetUserHasSkill,
	},
	mutations: {
		SET_CAMPAIGN: (state, data) => {state.campaign = data;},
		SET_CAMPAIGN_PAGINATION: (state, data) => {state.campaignPagination = {...state.campaignPagination, ...data};},
		SET_CAMPAIGN_PAGINATION_FILTER: (state, data) => {state.campaignPaginationFilter ={...state.campaignPaginationFilter, ...data};},
		SET_TARGET_USER_LIST: (state, data) => {state.targetUserList = data;},
		SET_TARGET_USER_LIST_PAGINATION: (state,data) => {state.targetUserListPagination = {...state.targetUserListPagination, ...data};},
		SET_TARGET_USER_LIST_PAGINATION_FILTER: (state,data) => {state.targetUserListPaginationFilter = {...state.targetUserListPaginationFilter,...data};},
		SET_CAMPAIGN_USER_LIST:(state,data) => {state.campaignUser = data;},
		SET_CAMPAIGN_USER_LIST_PAGINATION:(state,data) => {state.campaignUserListPagination = {...state.campaignUserListPagination,...data};},
		SET_CAMPAIGN_USER_LIST_FILTER:(state,data)=> {state.campaignUserListFilter ={...state.campaignUserListFilter, ...data};},
		SET_TRUST_SKILLS:(state,data) => {state.trustSKills = data},
		SET_TARGET_USER_HAS_SKILL:(state,targetUserHasSkill) => {state.targetUserHasSkill = targetUserHasSkill},

	},
	actions: {
		setCampaignUserListPage:({commit,state},page)=> {
			const $skip = (page - 1) * state.campaignUserListPagination.$limit;
			commit('SET_CAMPAIGN_USER_LIST_PAGINATION', { $skip });
			commit('SET_CAMPAIGN_USER_LIST_FILTER', { $skip });
		},
		setTargetUserListPage:({commit,state},page)=> {
			const $skip = (page - 1) * state.targetUserListPagination.$limit;
			commit('SET_TARGET_USER_LIST_PAGINATION', { $skip });
			commit('SET_TARGET_USER_LIST_PAGINATION_FILTER', { $skip });
		},
		setCampaignPage:({commit, state},page) => {
			const $skip = (page - 1) * state.campaignPagination.$limit;
			commit('SET_CAMPAIGN_PAGINATION', { $skip });
			commit('SET_CAMPAIGN_PAGINATION_FILTER', { $skip });
		},
		loadActionQualifierKeys: async({rootGetters}, type) => {
			const results = await feathersClient.service('/api/v3/action-qualifier-keys').find({
				query: {actionType : type}
			});
		return results;
		},
		getCampaignForList: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/intervention-campaigns').find({
				query:{
					fields: ['campaignProgress','staffs'],
					$role: rootGetters.currentUserRole,
					...filter,
					// $search:filter.searchText,
					$sort:{updatedAt : -1},
				},
			});
			commit('SET_CAMPAIGN',results.data);
			commit('SET_CAMPAIGN_PAGINATION', { total: results.total });
			return results.data;
		},
		getIntervententionCampaigns: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/intervention-campaigns').find({
				query:{
					fields: ['actions','qualifiers','incentives','targetGroupUser','trust','campaignProgress','staffs'],
					$role: rootGetters.currentUserRole,
					...filter,
					// $search:filter.searchText,
				},
			});
			commit('SET_CAMPAIGN',results.data);
			commit('SET_CAMPAIGN_PAGINATION', { total: results.total });
			return results.data; 
		},
		getIntervententionCampaignsById: async({rootGetters,commit},id) => {
			
			const results = await feathersClient.service('/api/v3/intervention-campaigns').get(id,{
				query:{
					fields: ['actions','qualifiers','incentives','targetGroupUser','trust','campaignProgress','staffs','conditionalCampaign'],
					$role: rootGetters.currentUserRole,
					//$obsolete:query.$obsolete || false,
				},
			});
		
			return results;
		},
		publishIntervention: async({rootGetters}, data)=> {
			const results = await feathersClient.service('/api/v3/intervention-campaigns').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		updateIntervention: async({rootGetters}, data)=> {
			return feathersClient.service('/api/v3/intervention-campaigns').patch(data.id,data,{
				query:{
					$role: rootGetters.currentUserRole,
				},
			});
		},
		trustSkills: async ({commit,rootGetters}, filter) => {
			const url = '/api/v3/skills';
			const results = await feathersClient.service(url).find({
				query:{
					$role: rootGetters.currentUserRole,
					status:'Active',
					$paginate:false,
				},
			});
			commit('SET_TRUST_SKILLS',results)
			return results;
		},
		getTargetedUsersCount: async({rootGetters,commit},query)=> {
			const results = await feathersClient.service('/api/v3/targeted-group-users').find({
				query:{
					...query,
				},
				});
			commit('SET_TARGET_USER_LIST',results.data);
			commit('SET_TARGET_USER_LIST_PAGINATION',{total: results.total})
			return results.total;
		},
		getCampaignListDetails: async({rootGetters},id) => {
			if(rootGetters.currentUserRolePermissions?.includes('EXPORT_CAMPAIGNS')){
				const resulte = await feathersClient.service('/api/v3/campaigns-summary').find({
					query: {
						$role:rootGetters.currentUserRole,
						trustId: id,
					},
				});
				return resulte;
			}
		},
		getCampaignsummaryById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/individual-campaign-summary').find({
				query:{
					$role:rootGetters.currentUserRole,
					campaignId: id,
				},
			});
			return results;
		},
		deleteCampaignById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/intervention-campaigns').remove(id,{
				query: {
					$role:rootGetters.currentUserRole,
				},
			});
			return results;
		},
		updateInterventionById:  async({rootGetters}, data)=> {
			const results = await feathersClient.service('/api/v3/intervention-campaigns').patch(data.id,data,{
				query:{
					$role: rootGetters.currentUserRole,
					$plannedToPublished : true,
				},
			});
			return results;
		},
		getUserForCampaign: async({rootGetters,commit}, query)=> {
			const id = query.id;
			delete query.id;
			const results = await feathersClient.service('/api/v3/user-campaigns').find({
				query:{
					campaignId: id,
					fields: ['user'],
					...query,
				},
			});
			commit('SET_CAMPAIGN_USER_LIST',results.data);
			commit('SET_CAMPAIGN_USER_LIST_PAGINATION', { total: results.total });
			return results.total;
		},
		getJobTitleTypes: async ({rootGetters,commit},query)=>{
			const results = await feathersClient.service('api/v3/job-title-types').find({
				query:{
					...query,
					$paginate:false,
				},
			});
			return results;
		},
		getTheExportData: async ({rootGetters,commit},id) =>{
			const results = await feathersClient.service('api/v3/export-campaigns').find({
				query:{
					$role: rootGetters.currentUserRole,
					campaignId:id,
				}
			});
			return results;
		},
		loadValidCampaigns:async({rootGetters,commit})=>{
			const results = await feathersClient.service('api/v3/intervention-campaigns').find({
				query:{
					$role:rootGetters.currentUserRole,
					$paginate:false,
					status:{$in:['RUNNING','PUBLISHED']},
					$sort:{updatedAt : -1},
				}
			});
			return results;
		},
		updateNameDescDate: async({rootGetters}, data)=> {
			const id= data.id
			delete data.id
			return feathersClient.service('/api/v3/intervention-campaigns').patch(id,data,{
				query:{
					$changeNameDescEndDate:true,
					$role: rootGetters.currentUserRole,
				},
			});
		},
	}
}
